var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgV2TournamentPrizeBurst(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 427.384,
    height: 658.091,
    viewBox: "0 0 427.384 658.091",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M193.176 0L213.69 338.259L234.205 0H193.176Z",
    fill: "url(#paint0_linear_0_28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M427.384 0H395.843L213.691 338.259L427.384 65.4143V0Z",
    fill: "url(#paint1_linear_0_28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M427.384 307.526L213.691 338.259L427.384 368.992V307.526Z",
    fill: "url(#paint2_linear_0_28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M427.384 658.091V611.104L213.691 338.259L385.919 658.091H427.384Z",
    fill: "url(#paint3_linear_0_28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M233.086 658.091L213.692 338.259L194.297 658.091H233.086Z",
    fill: "url(#paint4_linear_0_28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M0 658.091H41.4649L213.693 338.259L0 611.104V658.091Z",
    fill: "url(#paint5_linear_0_28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M0 368.992L213.693 338.259L0 307.526V368.992Z",
    fill: "url(#paint6_linear_0_28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M0 0V65.4143L213.693 338.259L31.541 0H0Z",
    fill: "url(#paint7_linear_0_28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M99.0586 0L213.692 338.259L147.011 0H99.0586Z",
    fill: "url(#paint8_linear_0_28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M282.714 0L213.691 338.259L331.06 0H282.714Z",
    fill: "url(#paint9_linear_0_28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M427.384 166.562L213.691 338.259L427.384 238.373V166.562Z",
    fill: "url(#paint10_linear_0_28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M427.384 441.645L213.691 338.259L427.384 514.048V441.645Z",
    fill: "url(#paint11_linear_0_28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M322.076 658.091L213.691 338.259L276.739 658.091H322.076Z",
    fill: "url(#paint12_linear_0_28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M148.432 658.091L213.694 338.259L102.719 658.091H148.432Z",
    fill: "url(#paint13_linear_0_28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M0 509.955L213.693 338.259L0 438.144V509.955Z",
    fill: "url(#paint14_linear_0_28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M0 234.873L213.693 338.259L0 162.47V234.873Z",
    fill: "url(#paint15_linear_0_28)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_28",
    x1: 221.441,
    y1: 325.521,
    x2: 218.673,
    y2: 48.1638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F047FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F047FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_28",
    x1: 213.691,
    y1: 326.628,
    x2: 383.649,
    y2: 60.8968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F047FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F047FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_28",
    x1: 384.203,
    y1: 344.898,
    x2: 221.996,
    y2: 344.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F047FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F047FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_28",
    x1: 221.442,
    y1: 349.326,
    x2: 399.803,
    y2: 601.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F047FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F047FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_28",
    x1: 207.602,
    y1: 343.236,
    x2: 202.619,
    y2: 657.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F047FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F047FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_28",
    x1: 169.958,
    y1: 395.838,
    x2: 37.0391,
    y2: 645.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F047FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F047FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_28",
    x1: 170.511,
    y1: 344.898,
    x2: 8.30412,
    y2: 344.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F047FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F047FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_0_28",
    x1: 203.728,
    y1: 326.532,
    x2: -50.7334,
    y2: 210.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F047FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F047FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_0_28",
    x1: 208.346,
    y1: 326.532,
    x2: 49.8124,
    y2: 277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F047FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F047FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_0_28",
    x1: 213.691,
    y1: 333.272,
    x2: 293.411,
    y2: 33.2165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F047FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F047FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_0_28",
    x1: 221.442,
    y1: 338.807,
    x2: 388.634,
    y2: 230.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F047FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F047FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_0_28",
    x1: 219.227,
    y1: 344.344,
    x2: 394.126,
    y2: 346.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F047FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F047FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_0_28",
    x1: 218.674,
    y1: 344.344,
    x2: 142.684,
    y2: 611.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F047FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F047FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_0_28",
    x1: 190.981,
    y1: 395.838,
    x2: 15.9957,
    y2: 546.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F047FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F047FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_0_28",
    x1: 169.958,
    y1: 369.169,
    x2: 119.292,
    y2: 524.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F047FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F047FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_0_28",
    x1: 203.728,
    y1: 332.165,
    x2: 3.87527,
    y2: 200.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F047FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F047FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2TournamentPrizeBurst);
export default __webpack_public_path__ + "static/media/v2_tournament_prize_burst.0bcda416e10d135e63e422ef7259c190.svg";
export { ForwardRef as ReactComponent };